import React from 'react';
import PropTypes from 'prop-types';
import { FieldAdapter as Field } from '@gqlapp/forms-client-react';
import RenderField from '@xem/look/Renders/Field';
import FieldWrap from "@gqlapp/base/FieldWrap";
import RegisterFormButton from "./RegisterFormButton";
import withCompose from './RegisterStepThree.Utils';

const RegisterForm = withCompose(({ setFieldValue, values, values:{ code } = {}, ...props}) => (<>
  <div className={'d-flex justify-content-center'} >
    <FieldWrap style={{ width: '200px'}}>
      <Field
        {...{
          onRemove: setFieldValue,
          component: RenderField,
          className: 'my-0',
          inputProps: { className: 'text-dark text-center' },
          name: 'code',
          label: '',
          placeholder: `user:account.phone.code`.t(),
          mask: [/\w/ , /\w/, ' ','-',' ', /\w/, /\w/ , ' ','-',' ', /\w/, /\w/ ],
          value: code
        }}
      />
    </FieldWrap>
  </div>
  <RegisterFormButton {...props} values={values} nextLabel={'user:verification'} />
</>));

RegisterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  errors: PropTypes.object,
  values: PropTypes.object,
  t: PropTypes.func
};


export default RegisterForm;
